import { useContext } from "react"
import SideNavItem from "./SideNavItem"
import { LayoutContext } from "../../context"
import { sideNavLinks } from "../../constants/enum.js"

function SideNav() {
  const { showSideNav } = useContext(LayoutContext)

  return (
    <aside
      id="logo-sidebar"
      className={` ${!showSideNav ? "-translate-x-full" : ""
        } fixed top-0 left-0 z-40 w-60 h-screen pt-20 transition-transform  
      bg-gradient-to-t from-gray-100 to-white
       border-r border-gray-200 lg:translate-x-0 dark:bg-gray-800 dark:border-gray-700`}
      aria-label="Sidebar"
    >
      <div className="h-full px-3 pb-4 overflow-y-auto 
      bg-gradient-to-t from-gray-50 to-white shadow-xl
             dark:bg-gray-800">
        <ul className="space-y-2 font-medium">
          {sideNavLinks.map((item, index) => {

            return <SideNavItem navItem={item} key={index} />
          })}
        </ul>
      </div>
    </aside>
  )
}

export default SideNav
